import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { EntityState } from "@@/shared/entity-status";
import type { MetaContent } from "@@/shared/meta-content/meta-content";
import type { Branded } from "@@/utilities/branded";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";

type SectionItemId = Branded<string, "SectionItemId">;
type SectionItem = {
    readonly _id: SectionItemId;
    readonly _type: "SECTION_ITEM";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly meta: MetaContent;
    readonly targetUrl: string;
};

type FactoryParams = "_id" | "_type" | "_createdAt";
type SectionItemCreateParams = Except<SectionItem, FactoryParams> & {
    _id?: SectionItemId;
    _status?: EntityState;
};
const createSectionItemId: SectionItemId = generateId({
    prefix: "section_item__",
});
const createSectionItem = (params: SectionItemCreateParams): SectionItem => {
    return {
        ...params,
        _id: params._id || createSectionItemId,
        _type: "SECTION_ITEM",
        _createdAt: nowIsoAndUnix(),
    };
};

export { createSectionItem };
export type { SectionItem, SectionItemCreateParams, SectionItemId };
